import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import { ReportNodeFragmentDoc } from '../fragments/reportNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllReportsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllReportsQuery = { __typename?: 'Query', allReports?: { __typename?: 'ReportNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'ReportNodeEdge', cursor: string, node?: { __typename?: 'ReportNode', id: string, carNumber?: string | null, crimeTime: any, issueTime: any, location?: string | null, reportNumber: string, source: Types.ComplaintsReportSourceChoices, car?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null, driver?: { __typename?: 'DriverNode', id: string, phone?: string | null, name: string, email?: string | null } | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, title?: Types.CustomersCustomerTitleChoices | null } | null, deal?: { __typename?: 'DealNode', id: string, status?: Types.DealsDealStatusChoices | null } | null } | null } | null> } | null };


export const AllReportsDocument = gql`
    query AllReports($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $customer: Float, $text: String) {
  allReports(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    customer: $customer
    text: $text
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...ReportNode
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}
${ReportNodeFragmentDoc}`;

/**
 * __useAllReportsQuery__
 *
 * To run a query within a React component, call `useAllReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      customer: // value for 'customer'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllReportsQuery(baseOptions?: Apollo.QueryHookOptions<AllReportsQuery, AllReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportsQuery, AllReportsQueryVariables>(AllReportsDocument, options);
      }
export function useAllReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportsQuery, AllReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportsQuery, AllReportsQueryVariables>(AllReportsDocument, options);
        }
export type AllReportsQueryHookResult = ReturnType<typeof useAllReportsQuery>;
export type AllReportsLazyQueryHookResult = ReturnType<typeof useAllReportsLazyQuery>;
export type AllReportsQueryResult = Apollo.QueryResult<AllReportsQuery, AllReportsQueryVariables>;